// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".reservation-input-type-radios[data-v-29a87b91]{-ms-flex-wrap:wrap;flex-wrap:wrap}.right-side[data-v-29a87b91]{margin-left:8px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
